const WeatherIcon = props => {
  return (
    <img className="weather-icon" src={'/icons/weather/_' + props.icon + '.png'} alt="" />
  );
};

export default WeatherIcon;